import {
  isHeicContentType,
  prepareHeicImage,
} from '~publish/components/ComposerImageWorkspace/prepareHeicImage'

export const prepareUploadFile = async (
  file: File,
  signal: AbortSignal,
): Promise<File> => {
  if (!isHeicContentType(file.type) && !/\.hei[cf]$/i.test(file.name)) {
    return file
  }

  const jpeg = await prepareHeicImage(file, signal, Infinity)
  const name = /\.hei[cf]$/i.test(file.name)
    ? file.name.replace(/\.hei[cf]$/i, '.jpg')
    : `${file.name}.jpg`
  return new File([jpeg], name, {
    type: 'image/jpeg',
    lastModified: file.lastModified,
  })
}
